import {
  EDIT_SKILL,
  EDIT_SKILL_CLEAN,
  EDIT_SKILL_SUCCESS,
  EDIT_SKILL_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  skill: undefined,
}

const SkillEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_SKILL:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_SKILL_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        skill: action.payload.skill,
      }
      break
    case EDIT_SKILL_CLEAN:
      state = initialState
      break
    case EDIT_SKILL_ERROR:
      state = {
        ...state,
        error: action.payload.error,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SkillEdit
